import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import styles from '../../cards.module.scss';
import { ButtonGroup } from 'primereact/buttongroup';
import { Button } from 'primereact/button';

function MemberItem({ member, handleClickMember, confirmMemberDeletion, layout }) {
  const onConfirmDeleteClick = (e, member) => {
    e.stopPropagation();
    confirmMemberDeletion(member);
  };
  return (
    <div className={`${styles.projectCard} `} onClick={handleClickMember}>
      <img
        className={styles.projectImage}
        src={member.logo ? member.logo.file : getImage('img-ph.png')}
        alt={member.logo ? member.logo.label : 'Non renseignée'}
      />

      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{member.name}</p>
          <p className={styles.subtitle}>{member.city.city}</p>
          <p className={styles.subtitle}>{member.email}</p>
          <p className={styles.subtitle}>{member.external_url}</p>
        </div>
        <div className={styles.tagList}>
          {member.type.map((p) => (
            <Tag
              tag={{
                label: p.label
              }}
              rounded
              key={p.id}
            />
          ))}
        </div>
      </div>
      {confirmMemberDeletion && (
        <ButtonGroup className={styles.buttonList}>
          <Button
            rounded
            icon="pi pi-trash"
            severity="danger"
            onClick={(e) => onConfirmDeleteClick(e, member)}
            outlined
            size="small"
            className="!h-9 !w-9"
          />
        </ButtonGroup>
      )}
    </div>
  );
}

export default MemberItem;
